import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import { S_Btn_Search, S_DateInput, S_Select, S_Title } from '~/components/SearchItem';

const styles = (theme) => ({
    root: {
    },
    menuItem: {
        '&.select-all, &.clear-all': {
            color: theme.palette.primary.main,
            fontWeight: 500,
        },
    },
    divider: {
        margin: '8px 0',
    },
});

const CustomItemPropSelect = (props) => {
    const { t, classes, label, onChange, options, selectedItems, type, style = {}, disabled = false } = props;

    const SPECIAL_VALUES = {
        SELECT_ALL: '__select_all__',
        CLEAR: '__clear__'
    };

    const handleChange = (event) => {
        event.stopPropagation();
        const value = event.target.value;
        
        let newValue;
        // 檢查最後選擇的值是否是特殊值
        const lastSelected = Array.isArray(value) ? value[value.length - 1] : value;

        if (lastSelected === SPECIAL_VALUES.SELECT_ALL) {
            newValue = options;
        } else if (lastSelected === SPECIAL_VALUES.CLEAR) {
            newValue = [];
        } else {
            newValue = value;
        }

        onChange({
            target: {
                value: newValue
            }
        }, type);
    };

    const isSelected = (id) => {
        return selectedItems.some(o => o.value === id);
    };
    
    return (
        <>
            <div style={{ marginLeft: 16 }}>
                <S_Title text={label} />
                <Select
                    labelId={`${type}-select-label`}
                    id={`${type}-select`}
                    style={{
                        backgroundColor: 'white',
                        width: 168,
                        height: 44,
                        fontSize: 16,
                        letterSpacing: '0.15px',
                        borderRadius: 8,
                        paddingLeft: 12,
                        ...style,
                    }}
                    multiple
                    value={selectedItems}
                    onChange={handleChange}
                    renderValue={(selected) => selected.map((o) => o.name).join(', ')}
                    MenuProps={{ 
                        style: { left: -12 },
                        PaperProps: {
                            style: {
                                maxHeight: 300
                            }
                        }
                    }}
                    disabled={disabled}
                >
                    <MenuItem 
                        value={SPECIAL_VALUES.SELECT_ALL}
                        className={`${classes.menuItem} select-all`}
                    >
                        全選 (Select All)
                    </MenuItem>
                    <MenuItem 
                        value={SPECIAL_VALUES.CLEAR}
                        className={`${classes.menuItem} clear-all`}
                    >
                        清除 (Clear)
                    </MenuItem>
                    <Divider className={classes.divider} />
                    {options.map((opt) => (
                        <MenuItem key={opt.value} value={opt}>
                            <Checkbox checked={isSelected(opt.value)} />
                            <ListItemText primary={opt.name} />
                        </MenuItem>
                    ))}
                </Select>
            </div>
        </>
    );    
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({  
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(CustomItemPropSelect);
